var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-database-upload",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "626"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.43,
    cy: 2.421,
    rx: 6.43,
    ry: 2.421,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.479,5.988 C2.963,5.988 0.032,4.986 0.032,4.314 L0.032,7.66 C0.032,8.874 2.919,9.856 6.479,9.856 C10.039,9.856 12.926,8.874 12.926,7.66 L12.926,4.314 C12.926,4.986 9.994,5.988 6.479,5.988 L6.479,5.988 Z",
    className: "si-glyph-fill"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.953,14.031 L7.906,14.031 L10.611,10.543 C9.48,10.819 8.024,11.018 6.447,11.018 C2.931,11.018 0,10.038 0,9.382 L0,12.651 C0,13.839 2.887,14.797 6.447,14.797 C7.767,14.797 8.931,14.664 9.953,14.438 L9.953,14.031 L9.953,14.031 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.018,14.969 L11.018,12.981 L10.016,12.981 L11.508,11.016 L12.984,12.981 L11.967,12.981 L11.967,14.969 L11.018,14.969 Z",
    className: "si-glyph-fill"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.71529f6f54f31660f21a2d494df25074.svg";
export { ForwardRef as ReactComponent };